export default "__VITE_ASSET__BOHbtb6b__"